"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNonsecureService = exports.useNonsecureServiceClient = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
function useNonsecureServiceClient() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.nonsecureServiceClientKey);
}
exports.useNonsecureServiceClient = useNonsecureServiceClient;
function useNonsecureService() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.nonsecureServiceKey);
}
exports.useNonsecureService = useNonsecureService;
//# sourceMappingURL=use-api.js.map